import { userActions } from '../actions';

const _checkValidAuthenticate = () => {
  const authData = sessionStorage.getItem('authData');
  const expirationtime = sessionStorage.getItem('expiration_time');

  if (authData && new Date().getTime() > expirationtime) {
    _refreshToken();
  }
};

export const _isAuthenticated = () => {
  _checkValidAuthenticate();
  const authData = sessionStorage.getItem('authData');
  const parsedData = authData ? JSON.parse(authData) : {};
  const { data, message, success } = parsedData || {};
  return {
    data,
    message,
    success,
  };
};

export const _refreshToken = async () => {
  const authData = sessionStorage.getItem('authData');
  const parsedData = authData ? JSON.parse(authData) : {};
  const { data, message, success } = parsedData || {};

  const refreshTokenRes = await userActions.refreshToken({
    refresh_token: data.refresh_token,
  });

  if (refreshTokenRes.code === 'OK') {
    const data = {
      ...parsedData.data,
      access_token: refreshTokenRes.data.access_token,
    };

    sessionStorage.setItem('authData', JSON.stringify({ data, message, success }));
    sessionStorage.setItem('expiration_time', new Date().getTime() + 10 * 60 * 1000);
  }
};
